import wheelTypes from "../../constants/wheelTypes";
import * as types from "../types";

const initialState = {
  userWheels: [],
  userPrivateWheels: [],
  userPublicWheels: [],
  userClonedWheels: [],
  userPrimaryWheel: null,
  pending: [],
  loading: {
    private: false,
    public: false,
    cloned: false,
    general: false,
    primary: false,
  },
  error: null,
};

const userWheelsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.USER_PRIVATE_WHEELS_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, private: true },
        error: null,
      };

    case types.USER_PUBLIC_WHEELS_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, public: true },
        error: null,
      };

    case types.USER_CLONED_WHEELS_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, cloned: true },
        error: null,
      };

    case types.USER_WHEELS_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, general: true },
        error: null,
      };

    case types.GET_USER_PRIMARY_WHEEL_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, primary: true },
        error: null,
      };

    case types.USER_WHEELS_SUCCESS:
      return {
        ...state,
        loading: false,
        userWheels: action.payload.results,
      };

    case types.USER_PRIVATE_WHEELS_SUCCESS:
      return {
        ...state,
        loading: { ...state.loading, private: false },
        userPrivateWheels: action.payload.results,
      };

    case types.USER_PUBLIC_WHEELS_SUCCESS:
      return {
        ...state,
        loading: { ...state.loading, public: false },
        userPublicWheels: action.payload.results,
      };

    case types.USER_CLONED_WHEELS_SUCCESS:
      return {
        ...state,
        loading: { ...state.loading, cloned: false },
        userClonedWheels: action.payload.results,
      };

    case types.GET_USER_PRIMARY_WHEEL_SUCCESS:
      return {
        ...state,
        loading: { ...state.loading, primary: false },
        userPrimaryWheel: action.payload,
      };

    case types.USER_PRIVATE_WHEELS_FAILURE:
    case types.USER_PUBLIC_WHEELS_FAILURE:
    case types.USER_CLONED_WHEELS_FAILURE:
    case types.USER_WHEELS_FAILURE:
    case types.GET_USER_PRIMARY_WHEEL_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          private: false,
          public: false,
          cloned: false,
          general: false,
          primary: false,
        },
        error: action.payload,
      };

    case types.ADD_USER_WHEEL_SUCCESS:
      const arr = state.userWheels.slice(0, -1);
      const wheelAlreadyExists = state.userWheels.some(
        (item) => item.id === action?.payload?.id
      );

      const newUserWheels = wheelAlreadyExists ? arr : [action.payload, ...arr];
      return {
        ...state,
        userWheels: newUserWheels,
      };

    case types.MAKE_WHEEL_PRIMARY:
      var newUserPrivateWheels = state.userPrivateWheels.filter(
        (wheel) => wheel.id !== action.payload.id
      );
      var newUserPublicWheels = state.userPublicWheels.filter(
        (wheel) => wheel.id !== action.payload.id
      );

      if (state.userPrimaryWheel) {
        newUserPublicWheels = [state.userPrimaryWheel, ...newUserPublicWheels];
      }
      return {
        ...state,
        userPrivateWheels: newUserPrivateWheels,
        userPublicWheels: newUserPublicWheels,
        userPrimaryWheel: action.payload,
      };

    case types.MAKE_WHEEL_PUBLIC:
      const privateTempArray = [...state.userPrivateWheels];
      const publicIndex = privateTempArray.findIndex(
        (item) => item.id === action?.payload
      );
      const wheelToMakePublic = privateTempArray[publicIndex];
      wheelToMakePublic["is_public"] = true;

      var newUserPrivateWheels = state.userPrivateWheels.filter(
        (wheel) => wheel.id !== wheelToMakePublic.id
      );
      var newUserPublicWheels = [wheelToMakePublic, ...state.userPublicWheels];

      return {
        ...state,
        userPrivateWheels: newUserPrivateWheels,
        userPublicWheels: newUserPublicWheels,
      };

    case types.MAKE_WHEEL_PRIVATE:
      if (action.payload === state.userPrimaryWheel?.id) {
        var newUserPrivateWheels = [
          state.userPrimaryWheel,
          ...state.userPrivateWheels,
        ];
        return {
          ...state,
          userPrivateWheels: newUserPrivateWheels,
          userPrimaryWheel: null,
        };
      } else {
        const publicTempArray = [...state.userPublicWheels];
        const privateIndex = publicTempArray.findIndex(
          (item) => item.id === action?.payload
        );
        const wheelToMakePrivate = publicTempArray[privateIndex];
        wheelToMakePrivate["is_public"] = false;

        var newUserPublicWheels = state.userPublicWheels.filter(
          (wheel) => wheel.id !== wheelToMakePrivate.id
        );
        var newUserPrivateWheels = [
          wheelToMakePrivate,
          ...state.userPrivateWheels,
        ];

        return {
          ...state,
          userPrivateWheels: newUserPrivateWheels,
          userPublicWheels: newUserPublicWheels,
        };
      }

    case types.REMOVE_USER_WHEEL_SUCCESS:
      const { wheelType, wheelId } = action.payload;

      switch (wheelType) {
        case wheelTypes.private:
          var newTemp = state.userPrivateWheels.filter(
            (wheel) => wheel.id !== wheelId
          );
          return {
            ...state,
            userPrivateWheels: newTemp,
          };

        case wheelTypes.public:
          var newTemp = state.userPublicWheels.filter(
            (wheel) => wheel.id !== wheelId
          );
          return {
            ...state,
            userPublicWheels: newTemp,
          };

        case wheelTypes.clones:
          var newTemp = state.userClonedWheels.filter(
            (wheel) => wheel.id !== wheelId
          );
          return {
            ...state,
            userClonedWheels: newTemp,
          };

        case wheelTypes.main:
          return {
            ...state,
            userPrimaryWheel: null,
          };

        default:
          return { ...state };
      }

    case types.EDIT_USER_WHEEL_SUCCESS:
      if (action.payload.is_primary) {
        return {
          ...state,
          userPrimaryWheel: action.payload,
        };
      }
      if (action.payload.is_public) {
        const editedWheelIndex = state.userPublicWheels.findIndex(
          (wheel) => wheel.id === action.payload.id
        );
        const updatedUserPublicWheels = [...state.userPublicWheels];
        updatedUserPublicWheels[editedWheelIndex] = action.payload;

        return {
          ...state,
          userPublicWheels: updatedUserPublicWheels,
        };
      } else {
        const editedWheelIndex = state.userPrivateWheels.findIndex(
          (wheel) => wheel.id === action.payload.id
        );
        const updatedUserPrivateWheels = [...state.userPrivateWheels];
        updatedUserPrivateWheels[editedWheelIndex] = action.payload;

        return {
          ...state,
          userPrivateWheels: updatedUserPrivateWheels,
        };
      }

    case types.ADD_PENDING_WHEEL:
      return {
        ...state,
        pending: [...state.pending, action.payload],
      };

    case types.UPDATE_PENDING_WHEEL:
      const updatedIndex = state.pending.findIndex(
        (wheel) => wheel.temp_id === action.payload.temp_id
      );
      const updatedPendingWheels = [...state.pending];
      updatedPendingWheels[updatedIndex] = {
        ...updatedPendingWheels[updatedIndex],
        ...action.payload,
      };

      return {
        ...state,
        pending: updatedPendingWheels,
      };

    case types.REMOVE_PENDING_WHEEL:
      const temp = state.pending.filter(
        (obj) => obj.temp_id !== action.payload
      );
      return {
        ...state,
        pending: temp,
      };

    case types.LOGOUT:
      return initialState;

    default:
      return state;
  }
};
export default userWheelsReducer;
